var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIKakaoCircle02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.24 12.7031C17.2021 12.7031 11.5 17.2108 11.5 22.7757C11.5 26.3955 13.9173 29.5714 17.5451 31.347C17.2788 32.3398 16.5807 34.9507 16.4394 35.5076C16.2659 36.2017 16.6937 36.1896 16.9721 36.004C17.19 35.8587 20.4628 33.6311 21.8752 32.6707C22.642 32.7837 23.4329 32.8442 24.24 32.8442C31.2779 32.8442 36.98 28.3366 36.98 22.7716C36.98 17.2067 31.2779 12.7031 24.24 12.7031Z",
    fill: "#371C1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIKakaoCircle02);
export default __webpack_public_path__ + "static/media/i_kakao_circle_02.a074d6ac15a5a1ef23d6b4cfc4185de5.svg";
export { ForwardRef as ReactComponent };